export default "__VITE_ASSET__$PvHTO0t__"